import Head from "./Head"
import PartSelectionsArea from "./PartSelectionsArea";
import SectionSelectionsArea from "./SectionSelectionsArea";

function SelectionsArea({
  selectedState,
  onBaseSelectionChange = f => f,
  onPartSelectionChange = f => f,
  onSectionSelectionChange = f => f,
}) {
  return (
    <>
      <Head
        selectedState={selectedState}
        onSelect={onBaseSelectionChange}
      />
      <PartSelectionsArea
        selectedState={selectedState}
        onSelect={onPartSelectionChange}
      />
      <SectionSelectionsArea
        selectedState={selectedState}
        onSelect={onSectionSelectionChange}
      />
    </>
  );
}

export default SelectionsArea;
